var _class, _PixTable;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { VARIANTS } from '@1024pix/pix-ui/helpers/variants';
import { warn } from '@ember/debug';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import PixBlock from './pix-block';
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
let PixTable = (_class = (_PixTable = class PixTable extends Component {
  get variant() {
    const value = this.args.variant ?? 'primary';
    warn(`PixTable: @variant "${value}" should be ${VARIANTS.join(', ')}`, VARIANTS.includes(value), {
      id: 'pix-ui.pix-table.variant.not-valid'
    });
    return value;
  }
  get caption() {
    warn(`PixTable: @caption is required`, Boolean(this.args.caption), {
      id: 'pix-ui.pix-table.caption.required'
    });
    return this.args.caption;
  }
  get tableClass() {
    const tableClass = ['pix-table'];
    warn('PixTable: @condensed must be a boolean, default undefined', [true, false, undefined].includes(this.args.condensed), {
      id: 'pix-ui.pix-table.condensed.not-boolean'
    });
    if (this.args.condensed) {
      tableClass.push('pix-table--condensed');
    }
    return tableClass.join(' ');
  }
  get headerClass() {
    return `pix-table-header--${this.variant}`;
  }
  get captionClass() {
    return this.args.displayCaption ? 'pix-table__caption' : 'screen-reader-only';
  }
  get hasOnRowClick() {
    return typeof this.args.onRowClick === 'function';
  }
  onClick(row, event) {
    event.stopPropagation();
    if (this.hasOnRowClick) {
      this.args.onRowClick(row);
    }
  }
}, setComponentTemplate(precompileTemplate("\n    <PixBlock @variant={{@variant}} class={{this.tableClass}} ...attributes>\n      <table>\n        <caption class={{this.captionClass}}>{{this.caption}}</caption>\n        <thead class={{this.headerClass}}>\n          <tr>\n            {{yield null \"header\" to=\"columns\"}}\n          </tr>\n        </thead>\n        <tbody>\n          {{#each @data as |row index|}}\n            <tr class={{if this.hasOnRowClick \"pix-table__clickable-row\" \"\"}} {{on \"click\" (fn this.onClick row)}}>\n              {{yield row \"cell\" index to=\"columns\"}}\n            </tr>\n          {{/each}}\n        </tbody>\n      </table>\n    </PixBlock>\n  ", {
  strictMode: true,
  scope: () => ({
    PixBlock,
    on,
    fn
  })
}), _PixTable), _PixTable), _applyDecoratedDescriptor(_class.prototype, "onClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onClick"), _class.prototype), _class);
export { PixTable as default };